import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  /** Stagger position inside a list. Capped so the last item never feels late. */
  index?: number;
  className?: string;
  as?: 'div' | 'li' | 'section';
}

/**
 * One entrance per element, spent only where a block first comes into view.
 * Short, ease-out, and disabled entirely for reduced-motion visitors.
 */
export function Reveal({
  children,
  index = 0,
  className = '',
  as = 'div'
}: RevealProps) {
  const reduced = useReducedMotion();
  const Component = motion[as];
  if (reduced) {
    const Plain = as;
    return <Plain className={className} data-id="element-158" data-mp="2spti8lv4rgrn">{children}</Plain>;
  }
  return <Component className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.28,
    ease: [0.23, 1, 0.32, 1],
    delay: Math.min(index, 6) * 0.045
  }} data-id="element-159" data-mp="2xqhizz95vbz2">
      {children}
    </Component>;
}